const topics = [
  { name: '古装悬疑', count: '12.6万讨论', hot: true },
  { name: '科幻电影', count: '9.8万讨论', hot: true },
  { name: '街舞综艺', count: '8.3万讨论', hot: true },
  { name: '4K修复', count: '6.5万讨论', hot: false },
  { name: '犯罪剧情', count: '5.9万讨论', hot: false },
  { name: '权谋大剧', count: '5.2万讨论', hot: false },
  { name: '国产动漫', count: '4.8万讨论', hot: false },
  { name: '都市情感', count: '4.1万讨论', hot: false },
  { name: '经典港片', count: '3.7万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="relative py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">热门话题</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">全网热议的影视话题，参与讨论表达你的观点</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className={`group flex items-center gap-3 px-5 py-3 rounded-xl border cursor-pointer transition-all duration-200 ${
                topic.hot
                  ? 'bg-accent-500/10 border-accent-500/30 hover:bg-accent-500/15'
                  : 'bg-background-200/50 border-background-200/60 hover:border-primary-500/20 hover:bg-background-200/70'
              }`}
            >
              <span className={`text-sm font-medium ${topic.hot ? 'text-accent-400' : 'text-foreground-300'}`}>
                {topic.name}
              </span>
              <span className="text-xs text-foreground-600">{topic.count}</span>
              {topic.hot && (
                <span className="flex items-center">
                  <i className="ri-fire-line text-accent-500 text-xs"></i>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}